const rankingItems = [
  {
    id: 1,
    rank: 1,
    title: '航海王',
    subtitle: '尾田荣一郎 · 热血冒险',
    heat: '本周热度 9.8',
    tag: '连载中',
    image: 'https://readdy.ai/api/search-image?query=One%20Piece%20style%20pirate%20manga%20illustration%20with%20straw%20hat%20crew%20sailing%2C%20warm%20golden%20sunset%20ocean%20tones%2C%20adventure%20shonen%20manga%20art%2C%20dynamic%20ship%20composition%2C%20heroic%20atmospheric%20lighting&width=400&height=280&seq=rank-1&orientation=landscape',
  },
  {
    id: 2,
    rank: 2,
    title: '咒术回战',
    subtitle: '芥见下下 · 暗黑战斗',
    heat: '本周热度 9.6',
    tag: '连载中',
    image: 'https://readdy.ai/api/search-image?query=Jujutsu%20Kaisen%20style%20dark%20fantasy%20manga%20illustration%20with%20cursed%20energy%2C%20deep%20purple%20and%20black%20tones%2C%20supernatural%20battle%20art%2C%20intense%20dynamic%20composition%2C%20dramatic%20lighting&width=400&height=280&seq=rank-2&orientation=landscape',
  },
  {
    id: 3,
    rank: 3,
    title: '鬼灭之刃',
    subtitle: '吾峠呼世晴 · 剑戟奇谭',
    heat: '本周热度 9.5',
    tag: '已完结',
    image: 'https://readdy.ai/api/search-image?query=Demon%20Slayer%20style%20Japanese%20manga%20illustration%20with%20water%20breathing%20effects%2C%20elegant%20blue%20and%20red%20contrast%2C%20Taisho%20era%20aesthetic%2C%20flowing%20dynamic%20composition%2C%20emotional%20lighting&width=400&height=280&seq=rank-3&orientation=landscape',
  },
  {
    id: 4,
    rank: 4,
    title: '间谍过家家',
    subtitle: '远藤达哉 · 搞笑日常',
    heat: '本周热度 9.2',
    tag: '连载中',
    image: 'https://readdy.ai/api/search-image?query=Spy%20Family%20style%20comedy%20manga%20illustration%20with%20quirky%20family%20scene%2C%20warm%20pastel%20cream%20and%20coral%20tones%2C%20slice%20of%20life%20art%2C%20playful%20wholesome%20composition%2C%20gentle%20domestic%20lighting&width=400&height=280&seq=rank-4&orientation=landscape',
  },
  {
    id: 5,
    rank: 5,
    title: '葬送的芙莉莲',
    subtitle: '山田钟人 · 治愈奇幻',
    heat: '本周热度 9.0',
    tag: '连载中',
    image: 'https://readdy.ai/api/search-image?query=Frieren%20style%20fantasy%20manga%20illustration%20with%20elf%20mage%20in%20peaceful%20landscape%2C%20soft%20muted%20green%20and%20cream%20tones%2C%20contemplative%20atmospheric%20art%2C%20gentle%20melancholic%20composition%2C%20ethereal%20lighting&width=400&height=280&seq=rank-5&orientation=landscape',
  },
  {
    id: 6,
    rank: 6,
    title: '链锯人',
    subtitle: '藤本树 · 暗黑奇幻',
    heat: '本周热度 8.8',
    tag: '连载中',
    image: 'https://readdy.ai/api/search-image?query=Chainsaw%20Man%20style%20dark%20urban%20fantasy%20manga%20illustration%2C%20gritty%20red%20and%20charcoal%20tones%2C%20visceral%20action%20art%2C%20chaotic%20dynamic%20composition%2C%20harsh%20neon%20noir%20lighting&width=400&height=280&seq=rank-6&orientation=landscape',
  },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
            热门榜单
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            51漫画下载热度排行，发现最受读者欢迎的漫画作品
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {rankingItems.map((item) => (
            <a
              key={item.id}
              href="#index"
              className="group flex gap-4 p-4 bg-background-50 rounded-xl border border-background-200/60 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="flex-shrink-0 relative w-24 h-20 rounded-lg overflow-hidden">
                <img
                  src={item.image}
                  alt={`${item.title} - 51漫画下载`}
                  className="w-full h-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute top-0 left-0 w-7 h-7 flex items-center justify-center bg-primary-500 rounded-br-lg">
                  <span className="text-xs font-bold text-background-50">{item.rank}</span>
                </div>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <h3 className="font-heading text-base text-foreground-900 truncate">{item.title}</h3>
                  <span className="flex-shrink-0 px-1.5 py-0.5 text-[10px] font-medium bg-secondary-100 text-secondary-700 rounded whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <p className="text-xs text-foreground-500 mb-1.5 truncate">{item.subtitle}</p>
                <div className="flex items-center gap-1">
                  <div className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className="ri-fire-line text-accent-500 text-xs"></i>
                  </div>
                  <span className="text-xs font-medium text-accent-600">{item.heat}</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}